exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".firmware-manage .title[data-v-3bc6af5f] {\n  font-size: 16px;\n  font-weight: 600;\n  color: #252525;\n}\n.firmware-manage .search-form[data-v-3bc6af5f] {\n  margin-top: 20px;\n}\n.firmware-manage .search-form .add-version-btn[data-v-3bc6af5f] {\n  float: right;\n}\n.firmware-manage .linked[data-v-3bc6af5f] {\n  color: #275fe8;\n  cursor: pointer;\n}", ""]);

// exports
